
// const gallery = document.querySelector("#gallery");
// if (gallery) {
// 	gallery.classList.add("All");
// 	let all_button = document.querySelector("button.All");
// 	all_button.classList.add("active");
// }
// const galllery_buttons = document.querySelectorAll(".gallery__buttons button");
// galllery_buttons.forEach(button => {
// 	button.addEventListener("click", event => {
// 		let active = document.querySelector("button.active");
// 		active.classList.remove("active");

// 		gallery.className = "gallery " + button.className;

// 		button.classList.add("active");
// 	})
// });

const galleryButtons = document.querySelectorAll(".gallery__buttons button");
galleryButtons.forEach(button => {
	button.addEventListener("click", galleryButtonclick);
});
function galleryButtonclick(event) {
	remove_active();
	let clickedButton = event.target;
	// add class to button
	clickedButton.classList.add("active");
	// activate the images
	let imageClassName = clickedButton.classList[0];
	let targetImages = document.querySelectorAll(".gallery__image." + imageClassName);
	targetImages.forEach(ele => ele.classList.add("active"));

}
function remove_active() {
	let active = document.querySelectorAll(".gallery .active");
	if (active) {
		active.forEach(ele => ele.classList.remove("active"));
	}
}


// fire first element
if (galleryButtons.length > 0) {
	galleryButtons[0].click();
}
